import request from 'utils/request';
import config from 'config/Config';

export default class {
  // 查询合同协议列表
  static queryAgreementList(params) {
    return request({
      url: 'basic/contract/query/type',
      host: config.HOST_MALL,
      params
    });
  }

  // 获取合同协议详情
  static getAgreement(code) {
    return request({
      url: `basic/contract/query/${code}`,
      host: config.HOST_MALL
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Personal/Protection/ProtectionServ.js